// extracted by mini-css-extract-plugin
export var cardHeader = "_s1-0";
export var reorderHandle = "_s1-3";
export var titleArea = "_s1-1";
export var titleAreaWithHandle = "_s1-2";